import { createSelector } from 'reselect';
import { getScopes } from './getScopes';
import { CONVERSATIONS_HOSTED_EMAIL_ACCESS } from '../../constants/Scopes';
export const hasHostedEmailAccess = createSelector(getScopes, scopes => scopes.includes(CONVERSATIONS_HOSTED_EMAIL_ACCESS));